import { useQuery } from "@tanstack/react-query";

import { QueryKey } from "@/constants/shared";
import { makeRequest } from "@/network/api";
import { LeaderboardRecord } from "@/types";

export const useWalletAddressUserData = (walletAddress: string | undefined) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKey.StatsForWalletAddress, walletAddress],
    queryFn: async (): Promise<{
      stats: LeaderboardRecord;
      walletAddress: string;
    }> => {
      const response = await makeRequest(
        `stats/wallet?walletAddress=${walletAddress}`,
      );
      const responseJson = await response.json();
      if (responseJson.error) {
        throw new Error(responseJson.error);
      }
      return responseJson.data;
    },
    enabled: Boolean(walletAddress),
    refetchOnMount: false,
  });

  const { stats } = data ?? {};

  return { stats, isLoading: isLoading || !walletAddress, isError };
};
